/* Keeps page content clear of fixed bars overlaid at the top of the
   viewport. Two jobs:

   1. At-rest compensation: app embeds (promo bar, menu bar) inject
      position:fixed elements the theme applies no compensation for, so the
      page content starts underneath them. While the page sits at (or near)
      the top, measure the stack of full-width fixed bars anchored to the
      top edge — EXCLUDING the theme's own .fixed-header scroll-stick,
      which compensates itself — and pad #PageContainer down to match.

   2. Live overlay height: publish the CURRENT total height of everything
      fixed at the top edge (this time INCLUDING stuck .fixed-header bars)
      as --xg-fixed-bottom on <html>, re-measured on scroll. CSS uses it to
      keep sticky page elements (e.g. the product photo column, which
      theme.css pins at top:80px) riding BELOW the stuck header instead of
      sliding underneath it.

   No fixed bars -> padding 0 and --xg-fixed-bottom 0. Quiet by design. */
(function () {
  'use strict';
  var applied = false;
  var basePad = null;
  var debounceT = null;
  var lastVar = -1;

  function fixedStackBottom(includeStuck) {
    var bars = [];
    function walk(node, depth) {
      if (depth > 8) return;
      var kids = node.children;
      for (var i = 0; i < kids.length; i++) {
        var el = kids[i];
        var tag = el.tagName;
        if (tag === 'SCRIPT' || tag === 'STYLE' || tag === 'LINK' || tag === 'TEMPLATE' || el.id === 'PageContainer') continue;
        var stuck = el.classList && el.classList.contains('fixed-header');
        if (stuck && !includeStuck) continue;
        var cs = window.getComputedStyle(el);
        if (cs.position === 'fixed') {
          if (cs.display !== 'none' && cs.visibility !== 'hidden' && parseFloat(cs.opacity || '1') > 0.05) {
            var r = el.getBoundingClientRect();
            if (r.height > 0 && r.width > window.innerWidth * 0.5 && r.top < window.innerHeight * 0.5) {
              bars.push(r);
            }
          }
          continue; /* never descend into fixed subtrees */
        }
        if (stuck) continue; /* stuck-but-not-fixed shouldn't be descended either */
        if (cs.display !== 'none') walk(el, depth + 1);
      }
    }
    if (document.body) walk(document.body, 0);
    bars.sort(function (a, b) { return a.top - b.top; });
    var max = 0;
    for (var i = 0; i < bars.length; i++) {
      var r = bars[i];
      /* accumulate only a contiguous stack growing down from the top edge */
      if (r.top <= max + 2 && r.bottom > max && r.bottom < window.innerHeight * 0.6) max = r.bottom;
    }
    return max;
  }

  function publishVar() {
    var v = Math.round(fixedStackBottom(true));
    if (v !== lastVar) {
      lastVar = v;
      document.documentElement.style.setProperty('--xg-fixed-bottom', v + 'px');
    }
  }

  function apply() {
    publishVar();
    var target = document.getElementById('PageContainer');
    if (!target) return;
    if ((window.pageYOffset || document.documentElement.scrollTop || 0) > 40) return;
    if (basePad === null) {
      target.style.paddingTop = '';
      basePad = parseFloat(window.getComputedStyle(target).paddingTop) || 0;
    }
    var h = Math.round(fixedStackBottom(false));
    if (h > 0) {
      target.style.paddingTop = (basePad + h) + 'px';
      applied = true;
    } else if (applied) {
      target.style.paddingTop = '';
      applied = false;
    }
  }

  function queue(ms) {
    clearTimeout(debounceT);
    debounceT = setTimeout(apply, ms || 150);
  }

  apply();
  setTimeout(apply, 700);
  setTimeout(apply, 2500);
  window.addEventListener('load', function () { queue(150); });
  window.addEventListener('pageshow', function () { queue(100); });
  window.addEventListener('resize', function () { basePad = null; queue(200); });
  var ticking = false;
  window.addEventListener('scroll', function () {
    if (ticking) return;
    ticking = true;
    (window.requestAnimationFrame || function (f) { setTimeout(f, 50); })(function () {
      ticking = false;
      publishVar();
      if ((window.pageYOffset || 0) <= 5) queue(80);
    });
  }, false);
  if (window.MutationObserver) {
    var mo = new MutationObserver(function () { queue(200); });
    mo.observe(document.documentElement, { childList: true, subtree: true });
    setTimeout(function () { mo.disconnect(); }, 12000);
  }
})();
